import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GenericDialogComponent } from '@app/management/dialogs/generic-confirm/generic-confirm.component';
import { AppointmentForm } from '@models/forms/appointment-form';
import { AppointmentFormService } from '@services/appointment-treatment-form.service';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';

interface Dict {
  [key: string]: any;
}

@Component({
  selector: 'app-treatment-form',
  templateUrl: './treatment-form.component.html',
  styleUrls: ['./treatment-form.component.scss'],
})
export class TreatmentFormComponent implements OnInit, OnDestroy {
  isIpad: boolean;
  isDirty: boolean = false;
  editable = true;
  eFormData: Dict = {};
  loading = true;
  modalView = false;
  unsub: Subject<void> = new Subject<void>();

  appointmentForm: AppointmentForm;

  constructor(
    private dialogService: MatDialog,
    @Optional() private dialogRef: MatDialogRef<TreatmentFormComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private appointmentFormService: AppointmentFormService
  ) {
    this.appointmentForm = data.appointmentForm;
    this.editable = data.editable;
  }

  ngOnInit() {
    this.isIpad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;

    if (this.dialogRef) {
      this.modalView = true;
    }
    this.loading = false;
  }

  private async confirmLeaveForm(): Promise<boolean> {
    const dialogRef = this.dialogService.open(GenericDialogComponent, {
      width: '300px',
      data: {
        title: 'Warning',
        content: 'You have unsaved changes to this eTreatment form. Are you sure you want to proceed?',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancel: true,
      },
    });
    let proceed = await dialogRef
      .afterClosed()
      .pipe(takeUntil(this.unsub))
      .map((result) => result === 'confirm')
      .toPromise();
    return proceed;
  }

  onFormSubmit(data) {
    this.loading = true;
    this.eFormData = data;
    this.appointmentFormService
      .updateAppointmentForm(this.appointmentForm, data)
      .pipe(first())
      .subscribe(() => {
        this.loading = false;
        this.isDirty = false;
        this.closeDialog();
      });
  }

  onFormChange(data) {
    this.isDirty = data.isModified;
  }

  pageRendered(event) {
    this.loading = false;
  }

  async closeDialog() {
    if (this.isDirty) {
      let proceed = await this.confirmLeaveForm();
      if (!proceed) {
        return;
      }
    }
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
